/**
 * Daisi Backend API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum IncidentStatus {
  REPORTED = 'REPORTED',
  CONFIRMED = 'CONFIRMED',
  RESOLVED = 'RESOLVED',
}
